import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { isMediumViewport } from '../Hooks/useMedia';
import useWindowLocationHref from '../Hooks/useWindowLocation';
import CustomSelect from '../Inputs/custom-select';

const TabMenu = ({
  tabs,
  handleTabChange,
  showCount,
  showResponsiveDropdown,
  srLabel,
}) => {
  const handleClick = (key) => {
    handleTabChange(key);
  };

  const href = useWindowLocationHref();
  const isMedium = isMediumViewport();

  if (showResponsiveDropdown && isMedium) {
    return (
      <CustomSelect
        srLabel={srLabel}
        options={tabs.map((tab) => ({
          key: tab.key,
          value: tab.label + (showCount && ` (${tab.count})`),
        }))}
        selectedItem={tabs.find((tab) => tab.isActive)}
        onChange={(selectedOption) => {
          handleClick(selectedOption.key);
        }}
        id={'search'}
      />
    );
  }
  return (
    <nav className="c-tab-menu">
      <ul className="c-tab-menu__list">
        {tabs.map((tab) => (
          <li
            data-event-category="Syskonsajtsök 1177 Vårdperonal"
            data-event-action={tab.label}
            data-event-name={href || 'novalue'}
            data-event-value={tab.count}
            key={tab.key}
            className={'c-tab-menu__item'}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                handleClick(tab.key);
              }}
              className={classNames({
                'c-tab-menu__button': true,
                'c-tab-menu__button--active': tab.isActive,
              })}
              aria-label={tab.screenReaderText}
            >
              <span aria-hidden data-event-include>
                {tab.label}
                {showCount && ` (${tab.count})`}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

TabMenu.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      totalHits: PropTypes.number,
      isActive: PropTypes.bool.isRequired,
      screenReaderText: PropTypes.string,
    })
  ).isRequired,
  handleTabChange: PropTypes.func.isRequired,
  showCount: PropTypes.bool,
};

export default TabMenu;
